/* tslint:disable */
/* eslint-disable */
/**
 * kiwi-api-dev
 * 走行計画、走行実績、全VEC予実管理, HDmap可視化、POI DB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Point,
    PointFromJSON,
    PointFromJSONTyped,
    PointToJSON,
} from './';

/**
 * 
 * @export
 * @interface PlanMeta
 */
export interface PlanMeta {
    /**
     * 
     * @type {string}
     * @memberof PlanMeta
     */
    updated_at: string;
    /**
     * 
     * @type {string}
     * @memberof PlanMeta
     */
    updated_by: string;
    /**
     * 
     * @type {string}
     * @memberof PlanMeta
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof PlanMeta
     */
    fleet_id: string;
    /**
     * 
     * @type {string}
     * @memberof PlanMeta
     */
    created_by: string;
    /**
     * 
     * @type {string}
     * @memberof PlanMeta
     */
    car_id: string;
    /**
     * 
     * @type {object}
     * @memberof PlanMeta
     */
    plan_id: object;
    /**
     * 
     * @type {string}
     * @memberof PlanMeta
     */
    plan_name: string;
    /**
     * 
     * @type {number}
     * @memberof PlanMeta
     */
    distance?: number;
    /**
     * 
     * @type {string}
     * @memberof PlanMeta
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof PlanMeta
     */
    time?: number;
    /**
     * 
     * @type {Array<Point>}
     * @memberof PlanMeta
     */
    points?: Array<Point>;
}

export function PlanMetaFromJSON(json: any): PlanMeta {
    return PlanMetaFromJSONTyped(json, false);
}

export function PlanMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanMeta {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updated_at': json['updated_at'],
        'updated_by': json['updated_by'],
        'created_at': json['created_at'],
        'fleet_id': json['fleet_id'],
        'created_by': json['created_by'],
        'car_id': json['car_id'],
        'plan_id': json['plan_id'],
        'plan_name': json['plan_name'],
        'distance': !exists(json, 'distance') ? undefined : json['distance'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'time': !exists(json, 'time') ? undefined : json['time'],
        'points': !exists(json, 'points') ? undefined : ((json['points'] as Array<any>).map(PointFromJSON)),
    };
}

export function PlanMetaToJSON(value?: PlanMeta | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updated_at': value.updated_at,
        'updated_by': value.updated_by,
        'created_at': value.created_at,
        'fleet_id': value.fleet_id,
        'created_by': value.created_by,
        'car_id': value.car_id,
        'plan_id': value.plan_id,
        'plan_name': value.plan_name,
        'distance': value.distance,
        'comment': value.comment,
        'time': value.time,
        'points': value.points === undefined ? undefined : ((value.points as Array<any>).map(PointToJSON)),
    };
}


